module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_primaerlogo_troms_og_finnmark_neg.b77e874d.svg";